module.exports = __webpack_public_path__ + "static-portal/img/32.0aa79b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yingyong/32.jpg
// module id = 6aSP
// module chunks = 4